import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditStageModal = ({ show, onHide, currentName, onSave }) => {
  const [stageName, setStageName] = useState(currentName || '');

  useEffect(() => {
    setStageName(currentName || '');
  }, [currentName]);

  const handleSave = () => {
    if (stageName.trim()) {
      onSave(stageName.trim());
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fw-semibold">Edit Stage</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="px-4 pb-4">
        <Form.Group>
          <Form.Label className="fw-medium">
            Edit Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={stageName}
            onChange={(e) => setStageName(e.target.value)}
            className="py-3 rounded-3"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 pb-4">
        <Button variant="light" className="px-4" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          style={{ backgroundColor: '#FF6B00', borderColor: '#FF6B00' }}
          className="px-4"
          onClick={handleSave}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditStageModal;